export const init = () => {
  let comparisonTableEl = document.querySelectorAll(".js-comparison-table");
  let headerHeight = document.querySelector('.header')?.offsetHeight;

  if (comparisonTableEl.length === 0 && !headerHeight) return;




  comparisonTableEl.forEach(function (cur) {

    let rowMainEl = cur?.querySelector(".row-main");
    if (!rowMainEl) return;

    let rowMainLeftOffsetNum;
    const comparisonTableHeaderEl = cur?.querySelector(".s-comparison-table__header");
    const elTableRowAll = cur.querySelectorAll(".s-comparison-table__row");
    const elTableFoterRow = cur.querySelectorAll(".s-comparison-table__footer");


    const trickyHandleHeaderSize = () => {
      rowMainLeftOffsetNum = Number(window.getComputedStyle(rowMainEl).paddingLeft.replace("px", "")) + Number(window.getComputedStyle(rowMainEl).marginLeft.replace("px", ""));
      if (comparisonTableHeaderEl) {
        comparisonTableHeaderEl.style.cssText = `padding-left: ${rowMainLeftOffsetNum}px; padding-right: ${rowMainLeftOffsetNum}px;`;
      }

    }


    const stickyComparisonTableHeader = function () {
      const startElement = cur.querySelector(".s-comparison-table__header");
      if (startElement.getBoundingClientRect().y - (headerHeight / 2) < 0) {
        comparisonTableHeaderEl?.classList.add('js-comparison-table__header--scrolled');

      } else {
        comparisonTableHeaderEl?.classList.remove('js-comparison-table__header--scrolled');
      }
    }




    window.addEventListener('scroll', () => {
      stickyComparisonTableHeader();
    });
    // Do it on load
    stickyComparisonTableHeader();

    window.addEventListener('resize', function (event) {
      trickyHandleHeaderSize();
    }, true);





    const handleMobileSwitcherMenu = function () {
      elTableRowAll.forEach((cur) => {
        cur.querySelectorAll(".td")[1].classList.add("active");
      });

      elTableFoterRow.forEach((cur) => {
        cur.querySelectorAll(".td")[1].classList.add("active");
      });


      if (window.innerWidth < 1312) {
        comparisonTableHeaderEl.querySelectorAll(".td").forEach((cur, index) => {

          cur.addEventListener("click", () => {
            comparisonTableHeaderEl.querySelectorAll(".td").forEach((cur) => {
              cur.classList.remove("active");
            })
            cur.classList.add("active");

            elTableRowAll.forEach((cur1) => {
              cur1.querySelectorAll(".td").forEach((cur2) => {
                cur2.classList.remove("active");
              })
              cur1.querySelectorAll(".td")[index].classList.add("active");
            });
            elTableFoterRow.forEach((cur1) => {
              cur1.querySelectorAll(".td").forEach((cur2) => {
                cur2.classList.remove("active");
              })
              cur1.querySelectorAll(".td")[index].classList.add("active");
            });
          })
        })
      }


    }

    const columSum = cur.querySelectorAll(".s-comparison-table__header .td").length;
    const containerEl = cur.querySelector(".container");
    // const containerClassListMemory = containerEl.classList.value;



    containerEl?.classList.add(`grid-for-${columSum}`);

    handleMobileSwitcherMenu();

    trickyHandleHeaderSize();
  })
};